import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


export const TestimonialsBoxContainer = styled.div`
  font-family: "Outfit", sans-serif;


.reviews_item {
margin-bottom: 30px;
}

.reviews_boxed {
  background-color: #84F0CC;
  padding: 20px;
  position: relative;
border-radius: 20px;
  color: #021E40;
  font-size: 16px;
  line-height: 1.5;
}

.reviews_boxed::after {
    content: "";
    position: absolute;
    bottom: -17px;
    left: 34px;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-top: 20px solid #84F0CC;
    border-right: 20px solid transparent;
}

.reviwer_name {
margin-top: 20px;
  font-weight: 700;
  color: #021E40;
  font-size: 16px;
}
.reviews_item p.reviwer_name {
    margin-bottom: 2px;
}
.reviews_item  span.redfont {
    font-weight: 700;
    text-transform: uppercase;
}
@media (max-width: 1199px) {

}

@media (max-width: 1024px) {

}

@media (max-width: 767px) {

}

`;
